module.exports = __webpack_public_path__ + "img/dep_babyfoodandcare@2x.009ca0c7.png";